import styled, { css } from "styled-components";
import { Button } from "../../../design-system/components/primitives/Button/Button";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";

/**
 * Shared outline “Save as draft” affordance (Figma).
 * 8px radius, primary-500 border, structural-0 fill, 8×16 padding, 8px gap.
 */
export const StyledSaveDraftButton = styled(Button)<{ $headerMinWidth?: boolean }>`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${spacing[2]};
    padding: ${spacing[2]} ${spacing[4]};
    border-radius: ${borderRadius.lg};
    box-sizing: border-box;
    box-shadow: none;
    color: ${rawColors.primary[500]};
    background-color: ${rawColors.structural.white};
    border: 1px solid ${rawColors.primary[500]};

    ${({ $headerMinWidth }) =>
      $headerMinWidth &&
      css`
        min-width: 140px;
      `}

    &:hover:not(:disabled) {
      background-color: ${rawColors.primary[50]};
      border-color: ${rawColors.primary[500]};
      color: ${rawColors.primary[500]};
      box-shadow: none;
      transform: none;
    }

    &:active:not(:disabled) {
      background-color: ${rawColors.primary[50]};
      border-color: ${rawColors.primary[500]};
      box-shadow: none;
      transform: none;
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 2px ${rawColors.primary[100]};
    }

    &:disabled {
      opacity: 0.45;
    }
  }
`;
